import { __decorate, __metadata } from "tslib";
import { containerResolver } from '../protocol/resolver';
import { Strategy } from '../types';
/**
 * Used to allow injecting dependencies but also passing data to the constructor.
 */
var FactoryResolver = /** @class */ (function () {
    /**
     * Creates an instance of the Factory class.
     * @param key The key to resolve from the parent container.
     */
    function FactoryResolver(key) {
        this._key = key;
    }
    FactoryResolver_1 = FactoryResolver;
    /**
     * Creates a Factory Resolver for the supplied key.
     * @param key The key to resolve.
     * @return Returns an instance of Factory for the key.
     */
    FactoryResolver.of = function (key) {
        return new FactoryResolver_1(key);
    };
    /**
     * Called by the container to pass the dependencies to the constructor.
     * @param container The container to invoke the constructor with dependencies and other parameters.
     * @return Returns a function that can be invoked to resolve dependencies later, and the rest of the parameters.
     */
    FactoryResolver.prototype.get = function (container, key) {
        var _key = this._key;
        var resolver = container.getResolver(_key);
        if (resolver && resolver.strategy === Strategy.Function) {
            _key = resolver.state;
        }
        // tslint:disable-next-line:only-arrow-functions
        return function () {
            var rest = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                rest[_i] = arguments[_i];
            }
            return container.invoke(_key, rest);
        };
    };
    var FactoryResolver_1;
    FactoryResolver = FactoryResolver_1 = __decorate([
        containerResolver,
        __metadata("design:paramtypes", [Object])
    ], FactoryResolver);
    return FactoryResolver;
}());
export { FactoryResolver };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRmFjdG9yeVJlc29sdmVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiRmFjdG9yeVJlc29sdmVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFPQSxPQUFPLEVBQUUsaUJBQWlCLEVBQUUsTUFBTSxzQkFBc0IsQ0FBQztBQUN6RCxPQUFPLEVBQWdDLFFBQVEsRUFBRSxNQUFNLFVBQVUsQ0FBQztBQUVsRTs7R0FFRztBQUVIO0lBYUk7OztPQUdHO0lBQ0gseUJBQW1CLEdBQVc7UUFDMUIsSUFBSSxDQUFDLElBQUksR0FBRyxHQUFHLENBQUM7SUFDcEIsQ0FBQzt3QkFuQlEsZUFBZTtJQUN4Qjs7OztPQUlHO0lBQ1csa0JBQUUsR0FBaEIsVUFBc0QsR0FBVztRQUM3RCxPQUFPLElBQUksaUJBQWUsQ0FBSSxHQUFHLENBQUMsQ0FBQztJQUN2QyxDQUFDO0lBYUQ7Ozs7T0FJRztJQUNJLDZCQUFHLEdBQVYsVUFBVyxTQUFvQixFQUFFLEdBQVc7UUFDeEMsSUFBSSxJQUFJLEdBQUcsSUFBSSxDQUFDLElBQUksQ0FBQztRQUNyQixJQUFJLFFBQVEsR0FBRyxTQUFTLENBQUMsV0FBVyxDQUFDLElBQVcsQ0FBQyxDQUFDO1FBQ2xELElBQUksUUFBUSxJQUFLLFFBQWdCLENBQUMsUUFBUSxLQUFLLFFBQVEsQ0FBQyxRQUFRLEVBQUU7WUFDOUQsSUFBSSxHQUFJLFFBQWdCLENBQUMsS0FBSyxDQUFDO1NBQ2xDO1FBQ0QsZ0RBQWdEO1FBQ2hELE9BQU87WUFBVSxjQUFjO2lCQUFkLFVBQWMsRUFBZCxxQkFBYyxFQUFkLElBQWM7Z0JBQWQseUJBQWM7O1lBQzNCLE9BQU8sU0FBUyxDQUFDLE1BQU0sQ0FBQyxJQUFXLEVBQUUsSUFBSSxDQUFDLENBQUM7UUFDL0MsQ0FBTSxDQUFDO0lBQ1gsQ0FBQzs7SUFwQ1EsZUFBZTtRQUQzQixpQkFBaUI7O09BQ0wsZUFBZSxDQXFDM0I7SUFBRCxzQkFBQztDQUFBLEFBckNELElBcUNDO1NBckNZLGVBQWUifQ==